'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { Record } from 'immutable';
import { DEFAULT_COLOR } from 'MeetingsBase/constants/colors';
var defaults = {
  primaryColor: DEFAULT_COLOR,
  logoUrl: null,
  logoAltText: null,
  companyName: null
};

var Branding = /*#__PURE__*/function (_Record) {
  _inherits(Branding, _Record);

  function Branding() {
    _classCallCheck(this, Branding);

    return _possibleConstructorReturn(this, _getPrototypeOf(Branding).apply(this, arguments));
  }

  _createClass(Branding, null, [{
    key: "from",
    value: function from(json) {
      if (json) {
        var logoUrl = json.hasOwnProperty('logoUrl') ? json.logoUrl : json.companyLogo;
        var primaryColor = json.hasOwnProperty('primaryColor') ? json.primaryColor : json.accentColor;
        return new Branding({
          primaryColor: primaryColor || DEFAULT_COLOR,
          logoUrl: logoUrl,
          logoAltText: json.logoAltText,
          companyName: json.companyName
        });
      }

      return new Branding();
    }
  }]);

  return Branding;
}(Record(defaults));

export { Branding as default };